<template>
  <div class="d-flex justify-center align-center my-5">
    <v-tooltip v-if="noEventsInWorkflow" location="bottom">
      <template v-slot:activator="{ props }">
        <v-btn
          size="small"
          icon="mds:add"
          v-bind="props"
          @click.prevent="addStartPoint"
          :disabled="$store.state.isWorkflowDisabled"
        />
        <span>&nbsp;&nbsp;&nbsp;Add start point</span>
      </template>
      <span>No events in the workflow. Click on 'Add start point' to add one.</span>
    </v-tooltip>
    <v-tooltip v-else-if="!$route.params.eventId" location="bottom">
      <template v-slot:activator="{ props }">
        <div v-bind="props">
          Select event to <b>add cards</b>
        </div>
      </template>
      <span>To add a card, first select an event from the workflow</span>
    </v-tooltip>
    <template v-else-if="defaultCardType?.title">
      <v-progress-circular
        v-if="addCardLoading"
        size="14"
        width="1"
        class="mx-1"
        indeterminate>
      </v-progress-circular>
      <template v-else>
        <add-card-button
          :disabled="$store.state.isWorkflowDisabled"
          :show-ai-button="!!workflow.aiDescription"
          @click="addCard"
          @click-ai="addCardWithAi($route.params.eventId, defaultCardType?.id)"
        >
          <template #label>
            &nbsp;&nbsp;&nbsp;Add <b>{{ defaultCardType?.title }}</b> to the selected event
          </template>
        </add-card-button>
      </template>
    </template>
    <template v-else>
      <div>
        <aggregate-type-selector :cardTypes="cardTypes" />
      </div>
    </template>
  </div>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import { mapState, mapGetters } from 'vuex'
import AddCardButton from '@/components/AddCardButton'
import AggregateTypeSelector from '@/components/AggregateTypeSelector'
import { EventBus } from '@/event-bus/event-bus.js'

export default {
  components: {
    AggregateTypeSelector,
    AddCardButton
  },

  data () {
    return {
      addCardLoading: false
    }
  },

  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow,
      events: state => state.workflow.workflow.domainEvents,
      cardTypes: state => state.cardTypes.cardTypes
    }),
    ...mapGetters({
      defaultCardType: 'cardTypes/defaultCardType'
    }),
    noEventsInWorkflow () {
      return !this.events || Object.keys(this.events).length === 0
    }
  },

  methods: {
    addCardWithAi (eventId, cardTypeId) {
      EventBus.$emit('add-card-with-ai', eventId, cardTypeId)
    },
    async addStartPoint () {
      const newEventId = await workflowApi.addEventToWorkflow({
        type: 'bpmn:Task',
        parents: ['start'],
        description: 'New event'
      })
      this.$router.push({ path: '/workflow/' + this.workflow.projectId + '/' + this.workflow.id + '/' + newEventId }).catch(() => { })
    },
    async addCard () {
      this.addCardLoading = true
      const res = await workflowApi.createCard(this.$route.params.id, this.$route.params.eventId)
      this.addCardLoading = false
      if (res.cards?.length) {
        this.$emit('focus-card', { id: res.cards[0].id })
      }
    }
  }
}
</script>
